import Page, { getStaticProps as compGetStaticProps } from 'components/pages/RegisterCompany';

export const getStaticProps = compGetStaticProps;
export default Page;
